
              import "_sentry-module-metadata-injection-stub";
              import * as OriginalModule from "/var/www/vhosts/roh_production/reviveourhearts_com/public/static/js/app/modules/glidejs/books.a1e9f0225fe5.js";
              export default OriginalModule.default;
              export * from "/var/www/vhosts/roh_production/reviveourhearts_com/public/static/js/app/modules/glidejs/books.a1e9f0225fe5.js";